module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    staticClass: "nav justify-content-end mobile-menu",
    attrs: {
      "right": "",
      "is-nav": "",
      "text": "jump to"
    }
  }, _vm._l((_vm.anchorsList), function(item) {
    return _c('b-dropdown-item', {
      key: item.anchor
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '#' + item.anchor
        }
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-938eba58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/for-authors/ForAuthorsPageMobileMenu.vue
// module id = 1463
// module chunks = 1